<template style="height:100%">
  <div class="Chart_add">
    <el-form label-width="80px" style="padding-top: 20px;margin-left: 20px;">
      <el-form-item label="量表名称">
        <el-input placeholder="量表名称" v-model="paperId" :disabled="true">
          <template slot="append" > <span style="cursor: pointer;" @click="cel()">选择量表</span></template>
        </el-input>
      </el-form-item>

      <el-form-item label="统计图表名称">
        <el-input placeholder="量表名称" v-model="statisitcChartName" >
        </el-input>
      </el-form-item>

      <el-form-item label="图表类型:">
 
        <el-radio-group v-model="chartType">
          <el-radio label="Column">直方图</el-radio>
          <el-radio label="Polar">雷达图</el-radio>
          <el-radio label="Line">折线图</el-radio>
          <el-radio label="MMPI">MMPI手绘图</el-radio>
          <el-radio label="16PF">16PF手绘图</el-radio>
          <el-radio label="Rainbow">彩带图</el-radio>
          <el-radio label="ColouredRibbon">彩虹图</el-radio>
        </el-radio-group>


      </el-form-item>

      <el-form-item label="统计类型:">
        <el-checkbox-group v-model="reportItemType">
          <el-checkbox label="IniScore" name="type">原始分</el-checkbox>
          <el-checkbox label="StandScore" name="type">标准分</el-checkbox>
          <el-checkbox label="AverageScore" name="type">平均分</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="统计项:">
        <el-checkbox-group v-model="reportItem">
          <el-checkbox v-for="(item,i) in yz" :key="i" :label="item.factorid" name="type">{{item.factorname}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="排序">
        <el-input placeholder="排序" v-model="lineNumber" >
        </el-input>
      </el-form-item>

      <el-form-item label="是否启用:">
        <el-switch v-model="isActive" active-text="启用" inactive-text="不启用"></el-switch>
      </el-form-item>

      <h2>刻度</h2>

      <el-form-item label="排序" style="margin-top:20px">
        <el-input placeholder="排序" v-model="kdpx" >
        </el-input>
      </el-form-item>

      <el-form-item label="开始维度">
        <el-input placeholder="开始维度" v-model="kdks" >
        </el-input>
      </el-form-item>

      <el-form-item label="结束维度">
        <el-input placeholder="结束维度" v-model="kdjs" >
        </el-input>
      </el-form-item>

      <el-form-item label="颜色">
        <el-select v-model="kdys" placeholder="请选择活动区域">
          <el-option v-for="item in data50" :key="item.dicKey" :label="item.cDicValue" :value="item.cDicValue">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="说明">
        <el-input placeholder="说明" v-model="kdsm" >
        </el-input>
      </el-form-item>

      <el-button type="primary" @click="addfun()">确定</el-button>
      
    </el-form>

    <el-dialog class="cscs" :visible.sync="dialogVisible" width="600px" style="height: 700px;" :before-close="handleClose">
      <scales_Pop @sendmsg="getmsg"></scales_Pop>
    </el-dialog>

  </div>
</template>
<script>
import scales_Pop from '@/components/scales_Pop.vue'
  export default {
    data() {
      return {
        data50:[],
        dialogVisible:false,
        chartType:'',
        paperId:'',
        statisitcChartName:'',
        chartId:'',
        reportItemType:[],
        reportItem:[],
        lineNumber:'',
        isActive:true,
        pId:'',
        yz:[],
        kdpx:'', 
        kdks:'', 
        kdjs:'', 
        kdys:'', 
        kdsm:'',
        chartCode:'',
      };
    },
    components:{
      scales_Pop
    },
    methods: {
      addfun(){
        var xs = []
        for(var i = 0;i< this.yz.length;i++){
          for(var j = 0;j< this.reportItem.length;j++){
            if(this.reportItem[j] == this.yz[i].factorid){
              xs.push(
                {
                  name:this.yz[i].factorname,
                  value:this.yz[i].factorid,
                  type:this.yz[i].type,
                }
              )
            }
          }
        }

        var scaleCgns = [{
          lineNumber:this.kdpx,
          startScale:this.kdks,
          endScale:this.kdjs,
          colorValue:this.kdys,
          remark:this.kdsm,
        }]

        this.$Http_Post('reportChartsCng/saveChartConfig', {
          paperId:this.pId,
          chartType:this.chartType,
          statisitcChartName:this.statisitcChartName,
          chartId:this.chartCode,
          reportItemType:this.reportItemType,
          reportItem:xs,
          lineNumber:this.lineNumber,
          isActive:this.isActive?'1':'0',
          scaleCgns:scaleCgns
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.yz = res.Data
            this.Global.request_successful(res.Message);
          }else{
            this.Global.request_failure(res.Message);
          }
        });

      },
      cel(){
        this.dialogVisible = true;
      },
      getmsg(val){//量表点击时子组件传过来值
        this.yz = [];
        this.paperId = val.label;
        this.pId = val.val;
        this.$Http_Get('reportChartsCng/getPaperFactor', {paperId:this.pId}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            for(var i = 0;i< res.Data.length;i++){
              res.Data[i].type = 'Factor'
            }
            res.Data.unshift({
              factorname:this.paperId,
              factorid:this.pId,
              type:'Paper',
            })
            this.yz = res.Data;
          }else{
            this.Global.request_failure(res.Message);
          }
        });
      },
      handleClose(done) {
        this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
      }
    },
    mounted(){
      if([this.$route.query.chartId][0]){
        this.chartCode = [this.$route.query.chartId][0];
        this.pId = [this.$route.query.paperId][0]
        this.$Http_Get('reportChartsCng/getChartInfo', {chartId:[this.$route.query.chartId][0]}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.paperId = res.Data.paperName;
            this.statisitcChartName = res.Data.statisitcChartName;
            this.chartType = res.Data.chartType;
            this.reportItemType = res.Data.reportItemType;
            this.lineNumber = res.Data.lineNumber;
            this.isActive = res.Data.isActive=='1'?true:false;
            this.kdpx = res.Data.scaleCgns[0].lineNumber;
            this.kdks = res.Data.scaleCgns[0].startScale;
            this.kdjs = res.Data.scaleCgns[0].endScale;
            this.kdys = res.Data.scaleCgns[0].colorValue;
            this.kdsm = res.Data.scaleCgns[0].remark;
            this.yz = [];
            var jhi = [];
            for(var i = 0;i< res.Data.reportItem.length;i++){
              jhi.push(res.Data.reportItem[i].value)
            }
            this.reportItem = jhi;
            this.$Http_Get('reportChartsCng/getPaperFactor', {paperId:[this.$route.query.paperId][0]}).then((res2) => {
              if (res2.Code == 200 || res2.Code == 0) {
                for(var i = 0;i< res2.Data.length;i++){
                  res2.Data[i].type = 'Factor'
                }
                res2.Data.unshift({
                  factorname:res.Data.paperName,
                  factorid:[this.$route.query.paperId][0],
                  type:'Paper',
                })
                this.yz = res2.Data;
              }else{
                this.Global.request_failure(res2.Message);
              }
            });
          }else{
            this.Global.request_failure(res2.Message);
          }
        });
      }


      this.$Http_Post('User/GetDictionaryList', { DicTypCode:50}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.data50 = res.Data

        }else{
          this.Global.request_failure(res.Message);
        }
      });
    }
  };
</script>
<style>
.Chart_add{width: 100%;height: 100%;background-color: #fff;}
.Chart_add .el-input, .el-textarea{width: 300px;}
.Chart_add .cscs .el-input, .el-textarea{width: 200px;}
</style>